import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardLayout from '../Dashboard/layout';


const UserView = () => {
  const { id } = useParams();  // Get the user id from the URL
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Simulating a fetch request for a single user
    const fetchUser = async () => {
      try {
        const users = [
          { id: 1, name: 'John Doe', role: 'Mentor', email: 'john@example.com', status: 'Active' },
          { id: 2, name: 'Jane Smith', role: 'Mentee', email: 'jane@example.com', status: 'Inactive' },
          { id: 3, name: 'Michael Brown', role: 'Mentor', email: 'michael@example.com', status: 'Blocked' },
          { id: 4, name: 'Emily White', role: 'Mentee', email: 'emily@example.com', status: 'Active' },
          { id: 5, name: 'Samuel Green', role: 'Mentor', email: 'samuel@example.com', status: 'Inactive' },
          { id: 6, name: 'Linda Gray', role: 'Mentee', email: 'linda@example.com', status: 'Active' }
        ];
        const user = users.find((user) => user.id === parseInt(id));
        setUser(user);
      } catch (error) {
        console.error('Failed to fetch user:', error);
      }
    };

    fetchUser();
  }, [id]);

  if (!user) {
    return <p>Loading...</p>;
  }

  return (
    <DashboardLayout>
      <h1>User Details</h1>
      <div>
        <strong>Name:</strong> {user.name}
      </div>
      <div>
        <strong>Role:</strong> {user.role}
      </div>
      <div>
        <strong>Email:</strong> {user.email}
      </div>
      <div>
        <strong>Status:</strong> {user.status}
      </div>
      <button onClick={() => navigate(`/edit-user/${user.id}`)}>Edit User</button>
      <button onClick={() => navigate('/ViewRegList')}>Back to View List</button>
    </DashboardLayout>
  );
};

export default UserView;
